/** Спільні тексти платформи: дії, стани помилки, одиниці. Використовують кілька областей. */
export const common = {
  appName: 'Clientline',
  close: 'Закрити',
  cancel: 'Скасувати',
  save: 'Зберегти',
  undo: 'Скасувати',
  retry: 'Спробувати ще раз',
  errorText: 'Сервер не відповів. Спробуйте ще раз за хвилину.',
  /** Заголовок вкладки, коли екран не відкрився (UX-07). */
  errorTitle: 'Помилка',
  supportCode: 'Код для підтримки',
  notFoundTitle: 'Сторінку не знайдено',
  optional: '(необов’язково)',
  noTime: '—',
  of: 'з',
  minutes: 'хв',
  /** «Скопіювати посилання» на запис (картка, рядок списку, `platform/record-link.ts`). */
  copyLink: 'Скопіювати посилання',
  linkCopied: 'Посилання скопійовано',
  linkNotCopied: 'Не вдалося скопіювати посилання',
  /** «Скопіювати ID» картки (FLD-24). */
  idCopied: 'ID скопійовано',
  idNotCopied: 'Не вдалося скопіювати ID',
  /** Чанк форми чи панелі не прийшов (смужка етапів, дошка, панель роботи із записом). */
  formUnavailable: 'Форма зараз недоступна. Спробуйте ще раз',
} as const;
